
<template>
  <swiper
    class="concept__grid"
    :modules="modules"
    :slides-per-view="3"
    :space-between="0"
    :touch-start-prevent-default="false"
    :loop="true"
    :navigation = "{ nextEl:'.site-index .slides__next', prevEl:'.site-index .slides__prev'}"
    @swiper="onSwiper"
    @slideChange="onSlideChange"
  >
    <swiper-slide class="concept__grid__item" v-for="(item, index) in list" :key="index">
      <div class="concept__grid__item__inner">
        <figure class="concept__grid__item__pic">
          <img :src="item.card" :alt="item.title">
        </figure>
        <div class="concept__grid__item__data isdata">
          <figure class="isdata__logo">
            <img :src="item.logo" :alt="item.title">
          </figure>
          <h2>{{ item.title }}</h2>
          <p v-html="item.text"></p>
        </div>
        <div class="btn">
          <Btn :href="item.link" :target="item.target" :class="item.color">{{item.linktext}}<svg width="11" height="10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="m6.143 9 4-4-4-4M10.143 5H1" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path></svg></Btn>
        </div>
      </div>
    </swiper-slide>
  </swiper>
</template>

<style lang="scss" scoped>
.concept{
  &__grid{
    &__item{
      padding: 0 1.2rem 2rem;
      height: auto;
      &__inner{
        height: 100%;
        background: module.$white;
        overflow: hidden;
        border-radius: 1rem;
        padding-bottom: 6.4rem;
        box-shadow: 0 .8rem 1.2rem rgba(module.$normal,.08);
        position: relative;
      }
      &__pic{
        width: 100%;
      }
    }
    .isdata{
      padding: 1.6rem 1.6rem 0;
      font-size: .92rem;
      line-height: 1.6;
      text-align: center;
      border-top: 0;
      &__logo{
        max-width: 72%;
        height: 2.4rem;
        margin: 0 auto;
        img{
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }
      h2{
        font-size: 1.04rem;
        margin: .64rem 0 1.4rem;
        padding: 0 0 1.4rem;
        border-bottom: module.$border 1px solid;
      }
    }
    .btn{
      position: absolute;
      left: 50%;
      bottom: 1.6rem;
      transform: translateX(-50%);
      width: 100%;
      text-align: center;
    }
  }
}
</style>

<script>
import { Navigation, Pagination, Scrollbar, A11y } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/vue'
import Btn from './Btn.vue'
export default {
  props: {
    list: {
      type: Array,
      required: true
    },
  },
  components: {
    Swiper,
    SwiperSlide,
    Btn,
  },
  setup() {
    const onSwiper = (swiper) => {
    }
    const onSlideChange = () => {
    }
    return {
      onSwiper,
      onSlideChange,
      modules: [Navigation, Pagination, Scrollbar, A11y],
    }
  },
}
</script>
